import { SESSION_STORAGE_BOOKING_TOKEN_NAME } from '../../utils/constants';

export const setSessionStorageItem = (key, data) => {
  sessionStorage.setItem(key, JSON.stringify(data));
};

export const removeSessionStorageItem = (key) => {
  sessionStorage.removeItem(key);
};

export const getSessionStorageItem = (key, shouldParseObject = true) => {
  const sessionStorageString = sessionStorage.getItem(key);
  return shouldParseObject ? JSON.parse(sessionStorageString) : sessionStorageString;
};

export const storeBookingToken = (token) => {
  sessionStorage.setItem(SESSION_STORAGE_BOOKING_TOKEN_NAME, token);
};

export const readStoredBookingToken = () => {
  const stored = sessionStorage.getItem(SESSION_STORAGE_BOOKING_TOKEN_NAME);
  if (!stored || stored.length < 2 || !stored.startsWith('"') || !stored.endsWith('"')) {
    return stored;
  }
  try {
    const parsed = JSON.parse(stored);
    return typeof parsed === 'string' ? parsed : stored;
  } catch {
    return stored;
  }
};
